import './required-field';

import $ from "jquery";
import plugin from "@core/plugins/lib";

const ELEMENT_SELECTOR = "[data-required-field]";
const PLUGIN_NAME = "requiredField";

$(() => {
	$(ELEMENT_SELECTOR).each(function() {
		const element = this;
		System.import(
			/* webpackChunkName: "required-field" */ "./required-field"
		).then((module) => {
			plugin(PLUGIN_NAME, module.default);
			$(element)[PLUGIN_NAME]();
		});
	});
});



// WEBPACK FOOTER //
// ./project/client/src/core/components/required-field/index--split.js